module.exports = __webpack_public_path__ + "img/car_susp.f3eaf6e6.svg";